/* eslint-disable import/no-duplicates */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import { MenuItem, Select, ToggleButton, ToggleButtonGroup } from '@mui/material';

import { inputTypes, defaultModalOptions } from '../../shared/constantVariable';
import '../../styles/parameters.scss';
import Notification from '../../shared/notification-modal';

function Params(props) {
  const {
    handleChangeParams,
    params = {},
    handleBlur,
    handleChangeUnit,
    units = {},
    inputMode,
    handleSelectInputMode,
    errors = {},
    chargeBalanceIon,
    setIsShowErrorMessage,
    translateObject,
    isShowNF_Feed
  } = props;
  const [modalOption, setModalOption] = useState(defaultModalOptions);

  const { temperatureFh, temperatureDc, tds, sdi, ph, malk, toc, pressure } = params;
  const handleConfirm = (e) => {
    setModalOption(defaultModalOptions);
    e.target.value = e.target.name === 'temperatureDc' ? 25.0 : 77.0;
    handleBlur(e);
  };

  const handleValidation = (e) => {
    const { name, value } = e.target;
    if (name === 'temperatureDc' && value <= 0) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Warning',
        message: 'Temperature must be in the range 0 °C - 100 °C',
        yesOrNo: false,
        onNo: () => handleConfirm(e), // handleConfirm(true),
      });
    } else if (name === 'temperatureFh' && value <= 32) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        title: 'Warning',
        message: 'Temperature must be in the range 32 °F - 212 °F',
        yesOrNo: false,
        onNo: () => handleConfirm(e), // handleConfirm(true),
      });
      e.target.value = 32.0;
      handleBlur(e);
    } else {
      handleBlur(e);
    }
  };

  return (
    <div className="saturation-modal h-14">
      <Notification
        options={modalOption}
        handleClose={() => setModalOption(defaultModalOptions)}
      />
      <div className="text-content no_drag M_Bold">{translateObject('Parameters')}</div>
      <div style={{ margin: '12px' }}>
        <div className="input-select-grid-feedForm" style={{ marginBottom: '8px' }}>
          <div className="header-text-black rufusReg no_drag M_Bold">{translateObject('Input')}</div>
          <div className={`select-dropdown sansW6SeBld ${isShowNF_Feed ? 'is-disabled-nf' : ''}`}>
            <Select
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
              value={inputMode}
              fullWidth
              onChange={handleSelectInputMode}
              disabled={chargeBalanceIon}
            >
              {(inputTypes || []).map((obj) => (
                <MenuItem key={obj.id} value={obj.id}>
                  <span dangerouslySetInnerHTML={{ __html: translateObject(obj.text) }} />
                </MenuItem>
              ))}
            </Select>
          </div>
        </div>
        <div className="form-field-v2-feedForm sansW4SeLig">
          <div className='input-label no_drag S_Regular'>{`${translateObject('Temperature')} (${units.temp})`}</div>
          <div className='temp-button-group'>
            <ToggleButtonGroup
              color="primary"
              value={units.temp}
              exclusive
              onChange={(e) => {
                setIsShowErrorMessage(true);
                localStorage.setItem('globalExitBtn', 'true');

                handleChangeUnit(e.target.value, e.target.value === '°F' ? temperatureDc : temperatureFh);
              }}
            >
              <ToggleButton className='degree' value="°C">°C</ToggleButton>
              <ToggleButton className='farenhit' value="°F">°F</ToggleButton>
            </ToggleButtonGroup>
          </div>
          <div className='input-field-temp no_drag'>
            {units.temp === '°C' && (<input
              // hiddenLabel
              // id="filled-hidden-label-small"
              name="temperatureDc"
              variant="outlined"
              onChange={handleChangeParams}
              value={temperatureDc}
              onBlur={handleValidation}
              onFocus={e => e.target.select()}
              type="number"
              className={errors.temperatureDc ? 'error-div  Form_Input_design S_Regular' : 'Form_Input_design S_Regular'}
              data-testid="temperatureDc"
            />)}
            {units.temp === '°F' && (<input
              // hiddenLabel
              // id="filled-hidden-label-small"
              name="temperatureFh"
              variant="outlined"
              onChange={handleChangeParams}
              value={temperatureFh}
              onBlur={handleValidation}
              onFocus={e => e.target.select()}
              type="number"
              className={errors.temperatureFh ? 'error-div Form_Input_design' : 'Form_Input_design'}
              data-testid="temperatureFh"
            />)}
          </div>
          {/* <div style={{ textAlign: 'left' }}>{validationDiv('temperatureDc')}</div> */}
        </div>
        <div className={`form-field-v2-feedForm sansW4SeLig ${isShowNF_Feed ? 'is-disabled-nf' : ''}`}>
          <div className='input-label no_drag S_Regular'>
            <span dangerouslySetInnerHTML={{ __html: translateObject('Total Alkalinity (ppm CaCO3)') }} />
          </div>
          <div className='input-field no_drag'>
            <input
              // hiddenLabel
              // id="filled-hidden-label-small"
              name="malk"
              variant="outlined"
              onChange={handleChangeParams}
              disabled={inputMode === 'ph_hco3' || inputMode === 'co2_hco3' || chargeBalanceIon}
              onFocus={e => e.target.select()}
              onBlur={handleValidation}
              value={malk}
              type="number"
              className={errors && errors.malk ? 'error-div Form_Input_design' : 'Form_Input_design'}
              data-testid="alkalinity"
            // style={{ borderRadius: '22px' }}
            />
          </div>
          {/* <div style={{ textAlign: 'left' }}>{validationDiv('malk')}</div> */}
        </div>
        <div className={`form-field-v2-feedForm sansW4SeLig ${isShowNF_Feed ? 'is-disabled-nf' : ''}`}>
          <div className='input-label no_drag S_Regular'>pH</div>
          <div className='input-field no_drag'>
            <input
              // hiddenLabel
              // id="filled-hidden-label-small"
              name="ph"
              variant="outlined"
              onChange={handleChangeParams}
              disabled={inputMode === 'co2_hco3' || chargeBalanceIon}
              onBlur={handleBlur}
              onFocus={e => e.target.select()}
              value={ph}
              type="number"
              className={errors.ph ? 'error-div Form_Input_design' : 'Form_Input_design'}
              data-testid="pH"
            />
          </div>
          {/* <div style={{ textAlign: 'left' }}>{validationDiv('ph')}</div> */}
        </div>
        <div className="form-field-v2-feedForm sansW4SeLig">
          <div className='input-label no_drag S_Regular'>TDS, mg/l</div>
          <div className='input-field no_drag'>
            <input
              // hiddenLabel
              // id="filled-hidden-label-small"
              key="tds"
              name="tds"
              variant="outlined"
              onChange={handleChangeParams}
              onBlur={handleBlur}
              onFocus={e => e.target.select()}
              value={tds}
              type="number"
              className={errors.tds ? 'error-div Form_Input_design' : 'Form_Input_design'}
              data-testid="tds"
            />
          </div>
          {/* <div style={{ textAlign: 'left' }}>{validationDiv('tds')}</div> */}
        </div>
        <div className="form-field-v2-feedForm sansW4SeLig">
          <div className='input-label no_drag S_Regular'>SDI</div>
          <div className='input-field no_drag'>
            <input
              // hiddenLabel
              // id="filled-hidden-label-small"
              name="sdi"
              variant="outlined"
              onChange={handleChangeParams}
              onBlur={handleBlur}
              onFocus={e => e.target.select()}
              value={sdi}
              type="number"
              className={errors.sdi ? 'error-div Form_Input_design' : 'Form_Input_design'}
              data-testid="sdi"
            />
          </div>
          {/* <div style={{ textAlign: 'left' }}>{validationDiv('sdi')}</div> */}
        </div>
        <div className="form-field-v2-feedForm sansW4SeLig">
          <div className='input-label no_drag S_Regular'>{translateObject('Total Organic Carbon')}, mg/l</div>
          {/* <div style={{ textAlign: 'left' }}>{validationDiv('toc')}</div> */}
          <div className='check'>
            <div className='input-field no_drag'>
              <input
                // hiddenLabel
                // id="filled-hidden-label-small"
                name="toc"
                variant="outlined"
                onChange={handleChangeParams}
                onBlur={handleBlur}
                onFocus={e => e.target.select()}
                value={toc}
                type="number"
                className={errors.toc ? 'error-div Form_Input_design' : 'Form_Input_design'}
                data-testid="organic-carbon"
              />
            </div>
          </div>
        </div>

        {/* <div className="form-field-v2-feedForm sansW4SeLig">
        <div className='input-label no_drag S_Regular'>{`Feed Flow (${units.flow})`}</div>
        <div className='input-field no_drag'>
          <TextField
            hiddenLabel
            id="filled-hidden-label-small"
            name="feedFlow"
            variant="outlined"
            onChange={handleChangeParams}
            onBlur={handleBlur}
            value={feedFlow} // {convertUnitValues(feedFlow, units.flow)}
            type="number"
            className={errors.feedFlow ? 'error-div input-innershadow' : 'input-innershadow'}
            data-testid="feedFlow"
          />
        </div>
      </div> */}

        <div className="form-field-v2-feedForm sansW4SeLig">
          <div className='input-label no_drag S_Regular'>{`${translateObject('Supply Pressure')} (${units.pressure})`}</div>
          <div className='input-field no_drag'>
            <input
              // hiddenLabel
              id="filled-hidden-label-small"
              name="pressure"
              variant="outlined"
              onChange={handleChangeParams}
              onBlur={handleBlur}
              value={pressure} // {convertUnitValues(pressure, units.pressure)}
              // value={convertUnitValues_pressure(pressure, localStorage.getItem('previous_pressure_unit') ? localStorage.getItem('previous_pressure_unit') : 'atm', units.pressure)}
              onFocus={e => e.target.select()}
              type="number"
              className='Form_Input_design'
              // className={errors.pressure ? 'error-div input-innershadow' : 'input-innershadow'}
              data-testid="pressure"
            />
          </div>
          {/* <div style={{ textAlign: 'left' }}>{validationDiv('pressure')}</div> */}
        </div>
      </div>
    </div>
  );
}

export default Params;
